import $ from 'jquery'

Ready(function() {
  const modalConfirmId = '#modal-confirm';
  const boxConfirmTemplateId = '#confirm-box-template';
  const attribute = 'data-confirm'

  const handleConfirm = function(event) {
    let native_button_element = event.target
    if (native_button_element.getAttribute(attribute) === null) {
      if (native_button_element.parentElement.getAttribute(attribute) === null) {
        return false
      } else {
        native_button_element = event.target.parentElement
      }
    }

    let button_element = $(native_button_element);
    let target = $(button_element.data('confirm-target')) //default is modal

    if (target.length == 0)
      showModal(native_button_element, button_element)
    else
      showBoxConfirm(native_button_element, button_element, target)

    return false // prevent default alert
  }

  const showModal = (native_button_element, button_element) => {
    let confirmElement = {}

    confirmElement = $(modalConfirmId);
    // Remove old colors
    confirmElement.removeClass('modal-danger')
    confirmElement.removeClass('modal-warning')
    confirmElement.removeClass('modal-success')

    // Add Colour
    confirmElement.addClass(classColor(button_element, 'modal'))

    confirmElement.find('.modal-title').html(button_element.data('confirm-header'));
    confirmElement.find('.modal-body').html(button_element.data('confirm'));
    new bootstrap.Modal(modalConfirmId, { backdrop: 'static' }).show();

    // handle buttons
    addButtonEventListener(native_button_element, confirmElement, true)
  }

  const classColor = (button_element, prefix) => {
    if (button_element.data('confirm-class'))
      return `${prefix}-${button_element.data('confirm-class')}`
    else
      return `${prefix}-success`
  }

  const showBoxConfirm = function(native_button_element, button_element, target) {
    let confirmElement = {}

    // Remove old confirm box
    confirmElement = $('.modal-content .confirm-box');
    if (confirmElement.length > 0) {
      confirmElement.remove()
    }

    // Copy confirm box to target location
    target.append($(boxConfirmTemplateId).html());

    // Get confirm box inside the modal
    confirmElement = $('.modal-content .confirm-box')

    // Add Colour
    confirmElement.addClass(classColor(button_element, 'confirm-box'))

    // In box confirm puts message in the header
    confirmElement.find('.confirm-box-title').html(button_element.data('confirm'));
    confirmElement.find('.confirm-box-body').html(button_element.data('confirm-body'));
    confirmElement.removeClass('d-none')

    // Handle butttons/
    addButtonEventListener(native_button_element, confirmElement, false)
  }

  const addButtonEventListener = (native_button_element, confirmElement, modal) => {
    // Accept
    confirmElement.find('.btn-success').on("click", function() {
      modalActionConfirmed(true, native_button_element, confirmElement, modal);
    });

    // Reject
    confirmElement.find('.btn-danger').on("click", function() {
      modalActionConfirmed(false, native_button_element, confirmElement, modal);
    });
  }

  const modalActionConfirmed = function(result, native_button_element, confirmElement, modal) {
    if (result) {
      var msg  = native_button_element.getAttribute(attribute)
      native_button_element.removeAttribute(attribute)
      native_button_element.click()
      native_button_element.setAttribute(attribute, msg)
    }

    if (modal) {
      // causes js error, modal hides so probably not needed
      //confirmElement.modal('hide');
    } else {
      confirmElement.remove()
    }
  }

  $('body').on('click', `a[${attribute}], input[type=submit][${attribute}], button[type=submit][${attribute}]`, handleConfirm);
});
